import { ready } from '@/lib/ready'
import { on } from '@/lib/dom/on'
import { slideDown } from '@/lib/animate/slideDown'
import { slideUp } from '@/lib/animate/slideUp'
import { loadCarousel } from '@/share/carousel'

import '@/share/styles/components/jcarousel.less'
import '@/share/styles/index.less'
import '@/share/global'
import '@/share/header'
import '@/share/footer'

import './styles/lp-deal-zone.less'

ready(() => {
  const carouselCateBanner = document.querySelector<HTMLElement>('#carouselCateBanner')
  if (carouselCateBanner) {
    loadCarousel(carouselCateBanner, {
      autoStart: true,
      interval: 5000,
      perPage: 1
    })
  }

  const jcarouselBrands = document.querySelector<HTMLElement>('#jcarousel-Brands')
  if (jcarouselBrands) {
    loadCarousel(jcarouselBrands, {
      autoStart: true,
      autoScrollNum: 1,
      responsive: {
        0: 2,
        450: 3,
        600: 4,
        750: 5,
        1000: 7
      }
    })
  }
  
  // init see more
  document.querySelectorAll('.deal-zone__item .deal-zone__description').forEach((item) => {
    const desc = item.querySelector('.deal-zone__description__content') as HTMLElement
    if (!desc) return
    if (desc.offsetHeight > 400) {
      const plink = item
        .closest('.deal-zone__item')!
        .querySelector('.deal-zone__name a')
        ?.getAttribute('href')
      const seeMore = document.createElement('a')
      seeMore.href = plink || 'javascript:void(0);'
      seeMore.innerText = 'See More'
      desc.after(seeMore)
      desc.classList.add('seemore')
    }
  })

  // on('.deal-zone__item .deal-zone__description a', 'click', (e: Event) => {
  //   const item = e.target as HTMLElement
  //   const desc = item.closest('.deal-zone__item')?.querySelector('.deal-zone__description__content') as HTMLElement
  //   if (!desc) return
  //   const text = item.innerText
  //   if (text === 'See More') {
  //     const top = window.scrollY
  //     item.innerText = 'See Less'
  //     desc.style.maxHeight = desc.scrollHeight + 'px'
  //   desc.dataset['top'] = top.toString()
  //     window.scrollTo({
  //       top: top,
  //       behavior: 'smooth'
  //     })
  //   } else {
  //     item.innerText = 'See More'
  //     desc.style.maxHeight = '350px'
  //   const top =  desc.dataset['top']
  //   if (top)
  //     window.scrollTo({
  //       top: parseInt(top),
  //       behavior: 'smooth'
  //     })
  //     desc.dataset['top'] = ''
  //   }
  // })
})
